
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[teamSchema]/gift_card",
      function () {
        return require("private-next-pages/[teamSchema]/gift_card.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[teamSchema]/gift_card"])
      });
    }
  